@import "../../../../styles/variables";

@mixin chat-animation {
  @keyframes hide-chat {
    0% {
      margin-top: 0;
      transform: translate(-50%, -50%);
    }

    90% {
      background-color: transparent;
      margin-top: -200px;
    }

    100% {
      transform: translate(-50%, 100%);
      visibility: hidden;
      pointer-events: none;
      opacity: 0;
    }
  }

  @keyframes show-chat {
    0% {
      background-color: transparent;
      margin-top: -140px;
      transform: translate(-50%, 100%);
    }

    70% {
      background-color: $svs-100-background;
    }

    100% {
      margin-top: 0;
      transform: translate(-50%, -50%);
    }
  }
}

.conversational-search-chat {
  @include chat-animation();

  background-color: $svs-100-background;
  display: initial;
  height: 100%;
  left: 50%;
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  width: calc(100% + 1px); // hide borders
  z-index: 55;

  @media (max-width: $uiaas-tablet) {
    z-index: 100; // Hide header
  }

  & > .conversational-search-chat-container {
    height: calc(100% - 195px);
    margin-top: 167px; // header size + spacing

    @media (max-width: 1200px) {
      height: calc(100% - 145px);
      margin-top: 115px; // header size + spacing
    }

    @media (max-width: $uiaas-tablet) {
      height: calc(100% - 30px); // spacing
      margin-top: -1px;
    }

    &-menu-open {
      height: calc(100% - 200px);
      margin-top: 175px;

      &-multi-account {
        height: calc(100% - 325px);
        margin-top: 300px;
      }
    }

    &-menu-not-open {
      height: calc(100% - 125px);
      margin-top: 100px;

      &-multi-account {
        height: calc(100% - 215px);
        margin-top: 185px;
      }
    }
  }

  &-content {
    height: calc(100% - -30px);
  }

  // combinations
  &--hidden {
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
  }

  &--animation-hidden {
    animation: hide-chat 1s forwards;
  }

  &--animation-visible {
    animation: show-chat 1s forwards;
  }
}
